/**
 * Logo on the navy header bars. It always uses the dark-mode logo (light
 * artwork); the "screen" blend drops a black background, as on the logos
 * uploaded in the Settings, so only the artwork shows on the navy.
 */
export const HeaderLogo = ({ src, alt }: { src: string; alt: string }) => (
  <img className="h-7 shrink-0 mix-blend-screen" src={src} alt={alt} />
);
